import {ServiceAdapter} from "./ServiceAdapter";
import {IContractData, IContractDataResponse, IContractEditData} from "./IContractData";
import {IAction} from "./IServiceAdapter";
import {ContractState} from "../ContractDataModels";

export type NpmContractStatus = "EXPIRED" | "OPEN" | "CLOSED" | "NEW" | "FROZEN";

export class NpmServiceAdapter extends ServiceAdapter<NpmContractStatus> {
    protected contractsApiPath = "contractManagement/npm";
    readonly availableActions: IAction<NpmContractStatus>[] = [{label: "Open", status: "OPEN"}, {
        label: "Close",
        status: "CLOSED"
    }];

    save(changedContractAreas: IContractEditData[], marketAreaCodes: string[]): Promise<any> {
        return Promise.all([
            this.saveStatusChange(changedContractAreas, marketAreaCodes, "OPEN", "OPEN"),
            this.saveStatusChange(changedContractAreas, marketAreaCodes, "CLOSED", "CLOSE")
        ]);
    }

    saveStatusChange(changedContractAreas: IContractEditData[], marketAreaCodes: string[], status: string, action: string): Promise<IContractData[]> {
        const changesToSave = changedContractAreas.filter(change => change.contractStatus === status);

        return changesToSave.length
            ? this.makeSaveRequest({
                contracts: changesToSave,
                action: action,
                marketAreaCodes: marketAreaCodes
            })
            : Promise.resolve([]);
    }

    contractManagementRequest(action: ContractState): Promise<any> {
        return Promise.resolve();
    }

    private makeSaveRequest(request: IContractDataResponse): Promise<IContractData[]> {
        return super.put<IContractData[]>(this.contractsApiPath, request);
    }

    getContracts(): Promise<IContractData[]> {
        return this.makeGetContractsRequest();
    }

    isContractStatusEditable(status: NpmContractStatus): boolean {
        switch (status) {
            case "OPEN":
            case "CLOSED":
            case "NEW":
            case "FROZEN":
                return true;
            default:
                return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/Services/NpmServiceAdapter.ts